import { Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { NAV, SITE } from "@/lib/site";
import { SiteSearch } from "@/components/SiteSearch";

export function Header() {
  const [open, setOpen] = useState(false);
  const [today, setToday] = useState("");
  useEffect(() => {
    setToday(new Date().toLocaleDateString("pt-BR", { weekday: "long", day: "2-digit", month: "long", year: "numeric" }));
  }, []);
  return (
    <header className="sticky top-0 z-40 border-b-2 border-primary bg-background/95 backdrop-blur-xl">
      <div className="bg-primary text-primary-foreground">
        <div className="container-svg flex items-center justify-between py-1 text-[11px] font-medium">
          <span className="capitalize min-h-[1em]">{today}</span>
          <span className="hidden sm:inline">Edição digital · Webjornal independente</span>
        </div>
      </div>
      <div className="container-svg flex h-[76px] items-center justify-between gap-4">
        <Link to="/" className="group flex items-center gap-2" aria-label={`${SITE.name} — Capa`}>
          <span aria-hidden className="inline-flex h-10 w-10 items-center justify-center rounded bg-accent font-bold text-primary text-lg leading-none border-2 border-primary">GR</span>
          <span className="flex flex-col leading-none">
            <span className="font-display text-xl md:text-2xl font-bold tracking-tight text-foreground">Gazeta Regional</span>
            <span className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground mt-0.5">Online · Webjornal</span>
          </span>
        </Link>
        <nav className="hidden items-center gap-0.5 lg:flex" aria-label="Principal">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              activeOptions={n.to === "/" ? { exact: true } : undefined}
              activeProps={{ className: "text-primary-foreground bg-primary" }}
              inactiveProps={{ className: "text-foreground hover:bg-accent" }}
              className="whitespace-nowrap rounded px-3 py-1.5 text-[13px] font-semibold uppercase tracking-wide leading-none transition-all"
            >
              {n.label}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <Link to="/auth" className="hidden md:inline-flex items-center rounded border-2 border-primary px-3 py-2 text-xs font-semibold uppercase tracking-wide text-primary hover:bg-primary hover:text-primary-foreground transition-colors">Cadastrar</Link>
          <Link to="/blog" className="hidden md:inline-flex btn-accent px-4 py-2 text-xs uppercase tracking-wide">Últimas notícias</Link>
          <button
            type="button"
            onClick={() => setOpen((o) => !o)}
            className="lg:hidden inline-flex h-11 w-11 items-center justify-center rounded border-2 border-primary bg-accent text-primary"
            aria-label="Abrir menu"
            aria-expanded={open}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden>
              {open ? <path d="M6 6l12 12M6 18L18 6" /> : <><path d="M4 7h16" /><path d="M4 12h16" /><path d="M4 17h16" /></>}
            </svg>
          </button>
        </div>
      </div>
      <div className="hidden md:block border-t border-border bg-secondary/60">
        <div className="container-svg py-2 flex justify-center">
          <div className="w-full max-w-2xl">
            <SiteSearch compact />
          </div>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-border bg-background">
          <nav className="container-svg flex flex-col py-3" aria-label="Menu mobile">
            <div className="mb-2"><SiteSearch compact /></div>
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                activeOptions={{ exact: n.to === "/" }}
                activeProps={{ className: "text-primary-foreground bg-primary" }}
                inactiveProps={{ className: "text-foreground hover:bg-accent" }}
                className="rounded px-3 py-3 text-sm font-semibold uppercase tracking-wide transition-colors"
              >
                {n.label}
              </Link>
            ))}
            <Link to="/blog" onClick={() => setOpen(false)} className="btn-accent mt-3 w-full">Últimas notícias</Link>
          </nav>
        </div>
      )}
    </header>
  );
}
